import rescript from "refractor/rescript";
export default rescript;